'use client';

import { RiShoppingBagLine } from '@remixicon/react';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';

type Props = {
  title: string;
  description: string;
};

export function TotemEmptyState({ title, description }: Props) {
  return (
    <div className="flex h-dvh w-full items-center justify-center bg-background p-6">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <RiShoppingBagLine />
          </EmptyMedia>
          <EmptyTitle>{title}</EmptyTitle>
          <EmptyDescription>{description}</EmptyDescription>
        </EmptyHeader>
      </Empty>
    </div>
  );
}
